import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ea7287c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-w-full tw-min-h-16 tw-gap-5 text" }
const _hoisted_2 = { class: "tw-flex tw-text-[13px] tw-font-normal tw-text-[#878787] tw-min-h-5" }
const _hoisted_3 = { class: "tw-text-[13px] tw-font-medium tw-text-[#211F58]" }

import { computed, h, ref, watch } from "vue";
import CustomTable, {
  type CustomTableColumn,
} from "@/components/common/customTable.vue";
import { getComponentUiText } from "@/utils/utilities";
import CellTableResultsDetails from "@/components/scanning/scanningTypes/cellTableResultsDetails.vue";
import CellTableResultStatus from "@/components/scanning/scanningTypes/cellTableResultStatus.vue";
import CellDetailType1 from "@/components/scanning/scanningTypes/cellDetailType1.vue";
import CellDetailType2 from "@/components/scanning/scanningTypes/cellDetailType2.vue";
import CellDetailType4 from "@/components/scanning/scanningTypes/cellDetailType4.vue";
import { isEmpty } from "underscore";
import { IModalMessage } from "@/interfaces/common/common";
import {
  MODAL_NAME,
  SCANNING_TABLE_RESULT_ITEM_TYPE,
  TYPE_SCHEDULE,
} from "@/utils/constants";
import { ChangeEvent } from "react";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

type TProps = {
  isLoading?: boolean;
  data?: TypeStatusItem[];
  scanTargetType?: keyof typeof TYPE_SCHEDULE;
  rootId: string;
  typeId: string;
  scanIgnores?: {
    ignoreId: string | null;
    ignoreScanItemId: string | null;
    ignoreForWebserviceId: string | null;
    ignoreForDomainId: string | null;
    ignoreNotes: string | null;
  }[];
};

type TypeStatusItem = {
  isShowDetail?: boolean;
  scanItemId: string;
  scanItem: string;
  scanItemOrder: number;
  scanItemSeverityId: string;
  scanItemSeverity: string;
  scanItemStatusId: string | null;
  scanItemStatus: string | null;
  scanItemStatusNotes: string | null;
  scanItemExpected: string;
  scanItemExpectedSpecific: string | null;
  scanItemFound: string | null;
  scanSubReportItemFound: string | null;
  scanItemFindingContext: object | string | null;
  scanItemFindingDatetime: string | null;
  scanSourceDatatime: string | null;
  scanSourceShodanRunId: string | null;
  scanSourceCMHRunId: string | null;
  scanSourceSSLLabsRunId: string | null;
  scanSourceMozObsRunId: string | null;
  scanSourceWhoisRunId: string | null;
  scanItemPostProcessingId: string | null;
  scanSubReportRunServiceScanTypeId: string | null;
  scanSubReportRunServiceTypeId: string | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'scanningTypeResults',
  props: {
    isLoading: { type: Boolean },
    data: {},
    scanTargetType: {},
    rootId: {},
    typeId: {},
    scanIgnores: {}
  },
  setup(__props: any) {

const props = __props;



const scanReportItemIgnores = computed<Record<string, any>[]>(() => {
  return store.getters["Scanning/getScanReportItemIgnores"];
});

const tableData = computed(() =>
  (props.data || []).map((item) => ({
    ...item,
    id: item.scanItemId, // or use another unique field if needed
  })),
);
const reasonText = ref("");
const disableCloseIgnoreModal = ref(false);

// watch(
//   () => props.data,
//   () => {
//     tableData.value = props.data;
//   },
// );

const tableFields: CustomTableColumn[] = [
  {
    text: getComponentUiText(
      "app-scan-scanning-types-table-results-header-cell-scan-item-1",
    ),
    value: "scanItem",
    headerClass:
      "!tw-text-[#fff] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
    valueClass: "!tw-pr-4 !tw-align-top tw-w-[25%]",
  },
  {
    text: getComponentUiText(
      "app-scan-scanning-types-table-results-header-cell-severity-1",
    ),
    value: "scanItemSeverityId",
    headerClass:
      "!tw-text-[#fff] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase tw-justify-center",
    sortable: false,
    valueClass: "!tw-pr-4 !tw-align-top",
  },
  {
    text: getComponentUiText(
      "app-scan-scanning-types-table-results-header-cell-status-1",
    ),
    value: "scanItemStatusId",
    headerClass:
      "!tw-text-[#fff] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase tw-justify-center",
    sortable: false,
    valueClass: "!tw-pr-4 !tw-align-top",
  },
  {
    text: getComponentUiText(
      "app-scan-scanning-types-table-results-header-cell-expected-result-1",
    ),
    value: "expectedResult",
    headerClass:
      "!tw-pr-[14px] !tw-text-[#fff] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
    valueClass: "!tw-pr-[14px] !tw-align-top tw-w-[25%]",
  },
  {
    text: getComponentUiText(
      "app-scan-scanning-types-table-results-header-cell-unexpected-result-1",
    ),
    value: "unexpectedResult",
    headerClass:
      "!tw-text-[#fff] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
    valueClass: "!tw-align-top tw-w-[25%]",
  },
];
const scanTypeId = {
  domain: getComponentUiText("app-scan-scanning-types-description-dns-1"),
  net: getComponentUiText(
    "app-scan-scanning-types-description-network-security-1",
  ),
  https: getComponentUiText("app-scan-scanning-types-description-tls-1"),
  tls_ssl: getComponentUiText("app-scan-scanning-types-description-ssl-1"),
  http_headers: getComponentUiText(
    "app-scan-scanning-types-description-http-headers-1",
  ),
  html: getComponentUiText("app-scan-scanning-types-description-html-1"),
};
const ItemStatus = {
  ok: "ok",
  na: null,
  partial: "par",
  no: "no",
  nap: "nap",
};

const getType1TitleForUnexpectedResult = (text: string) => {
  if (!text) {
    return "";
  }
  return text.substring(0, text.length / 2 - 7);
};

const renderValue = (value: any) => {
  return value === null ? "N/A" : `${value}`;
};

const getItemType = (item: TypeStatusItem) => {
  const hasIncludeItem = scanReportItemIgnores.value.some((scan) => {
    const parentId =
      props.scanTargetType === TYPE_SCHEDULE.webservices
        ? scan.ignoreForWebserviceId
        : scan.ignoreForDomainId;
    return (
      Number(parentId) === Number(props.rootId) &&
      scan.ignoreScanItemId === item.scanItemId &&
      !scan.isArchived
    );
  });
  return hasIncludeItem
    ? SCANNING_TABLE_RESULT_ITEM_TYPE.include
    : SCANNING_TABLE_RESULT_ITEM_TYPE.ignore;
};

const checkIsIgnored = (item: TypeStatusItem) => {
  return Boolean(item.scanItemPostProcessingId !== null);
};

const handleIgnoreOrIncludeItem = (
  item: TypeStatusItem,
  type: keyof typeof SCANNING_TABLE_RESULT_ITEM_TYPE,
) => {
  const isIgnore = type === SCANNING_TABLE_RESULT_ITEM_TYPE.ignore;
  disableCloseIgnoreModal.value = false;

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      headerTitle: isIgnore
        ? getComponentUiText(
            "app-scan-scanning-types-table-results-body-cell-item-modal-ignore-header-1",
          )
        : "",
      title: getComponentUiText(
        isIgnore
          ? "app-scan-scanning-types-table-results-body-cell-item-modal-ignore-title-1"
          : "app-scan-scanning-types-table-results-body-cell-item-modal-include-title-1",
      ),
      description: getComponentUiText(
        isIgnore
          ? "app-scan-scanning-types-table-results-body-cell-item-modal-ignore-description-1"
          : "app-scan-scanning-types-table-results-body-cell-item-modal-include-description-1",
      ),
      list: [],
      disableCloseModal: disableCloseIgnoreModal,
      slotCustom: h(
        "div",
        {
          class:
            "tw-flex tw-flex-1 tw-flex-col tw-gap-5 tw-text-[#231F20] tw-text-[14px]",
        },
        [
          h(
            "span",
            {},
            getComponentUiText(
              isIgnore
                ? "app-scan-scanning-types-table-results-body-cell-item-modal-ignore-description-2"
                : "app-scan-scanning-types-table-results-body-cell-item-modal-include-description-2",
            ),
          ),
          h("input", {
            type: "text",
            placeholder: getComponentUiText(
              "app-scan-scanning-types-table-results-body-cell-item-modal-ignore-input-reason-placeholder-1",
            ),
            class:
              "tw-w-full tw-p-3 tw-rounded-lg tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[rgba(239,240,241,0.5)]",
            onInput(event: ChangeEvent<HTMLInputElement>) {
              reasonText.value = event.target.value;
              reasonText.value && (disableCloseIgnoreModal.value = true);
              !reasonText.value && (disableCloseIgnoreModal.value = false);
            },
          }),
        ],
      ),
      buttonText: getComponentUiText(
        isIgnore
          ? "app-scan-scanning-types-table-results-body-cell-item-modal-ignore-button-ok-1"
          : "app-scan-scanning-types-table-results-body-cell-item-modal-include-button-ok-1",
      ),
      buttonRed: false,
      hiddenHelp: false,
      updateDataFunction: async () => {
        return await handleIgnore(item, isIgnore);
      },
    },
    events: {
      "update:data": () => {},
      "update:close": () => {
        reasonText.value = "";
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleIgnore = async (item, isIgnore) => {
  const defaultNote = getComponentUiText(
    "app-scan-scanning-types-table-results-body-cell-item-modal-ignore-reason-default-1",
  );
  let returnValue;
  const data: any = {
    scanTypeId: item.scanSubReportRunServiceScanTypeId,
    scanItemId: item.scanItemId,
    notes: reasonText.value || (isIgnore ? defaultNote : ""),
    [props.scanTargetType === TYPE_SCHEDULE.webservices
      ? "webserviceId"
      : "domainId"]: props.rootId,
  };
  if (isIgnore) {
    returnValue = await store.dispatch(
      "Scanning/handleIgnoreScanReportItem",
      data,
    );
    reasonText.value = "";
    return returnValue;
  }
  const ignoreItemIds = item.scanItemPostProcessingId
    ? [item.scanItemPostProcessingId]
    : [
        scanReportItemIgnores.value.find(
          (scan) => scan.ignoreScanItemId === item.scanItemId,
        )?.ignoreId,
      ];
  returnValue = await store.dispatch("Scanning/handleIncludeScanReportItem", {
    data,
    ignoreItemIds,
  });
  reasonText.value = "";
  return returnValue;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(scanTypeId[_ctx.typeId]), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-types-item-tls-result-1")), 1),
    _createVNode(CustomTable, {
      columns: tableFields,
      data: tableData.value,
      "show-checkbox-row": false,
      "header-wrapper-class": "table-header",
      "custom-class": `tls-vulnerabilities-table-wrap scanning-type-result ${
        tableData.value && tableData.value?.length <= 5
          ? 'tw-overflow-hidden'
          : 'tw-max-h-[500px]'
      }`,
      "is-loading": _ctx.isLoading,
      "hover-bg-color": '!tw-bg-[#F2F8FF80]',
      "empty-text": 
        _unref(getComponentUiText)(
          'app-scan-scanning-types-item-tls-result-table-empty-1',
        )
      
    }, {
      "cell(scanItem)": _withCtx(({
          value,
          item,
        }: {
          value: string;
          item: TypeStatusItem;
        }) => [
        _createElementVNode("span", {
          class: "tw-text-[12px] tw-font-normal tw-leading-none",
          style: _normalizeStyle(`color: ${checkIsIgnored(item) ? '#DBDBDB' : '#211F58'}`)
        }, _toDisplayString(value), 5)
      ]),
      "cell(scanItemSeverityId)": _withCtx(({
          value,
          item,
        }: {
          value: string;
          item: TypeStatusItem;
        }) => [
        _createVNode(CellTableResultStatus, {
          title: item.scanItemSeverity,
          "item-status-id": checkIsIgnored(item) ? null : value
        }, null, 8, ["title", "item-status-id"])
      ]),
      "cell(scanItemStatusId)": _withCtx(({
          value,
          item,
        }: {
          value: string;
          item: TypeStatusItem;
        }) => [
        _createVNode(CellTableResultStatus, {
          title: 
            checkIsIgnored(item)
              ? _unref(getComponentUiText)(
                  'app-scan-scanning-types-table-results-body-cell-unexpected-ignored-1',
                )
              : item.scanItemStatus
          ,
          "item-status-id": checkIsIgnored(item) ? null : value
        }, null, 8, ["title", "item-status-id"])
      ]),
      "cell(expectedResult)": _withCtx(({
          item,
        }: {
          value: string;
          item: TypeStatusItem;
        }) => [
        (item.scanItemStatusId === ItemStatus.ok || checkIsIgnored(item))
          ? (_openBlock(), _createBlock(CellTableResultsDetails, {
              key: 0,
              "class-name": "tw-border-r-0 tw-rounded-r-none",
              style: {"width":"calc(100% + 14px)"}
            }, {
              default: _withCtx(() => [
                _createVNode(CellDetailType1, {
                  title: renderValue(item.scanItemExpected),
                  "is-ignored": checkIsIgnored(item),
                  style: {"width":"calc(200% - 14px)"}
                }, null, 8, ["title", "is-ignored"])
              ]),
              _: 2
            }, 1024))
          : (typeof item.scanItemFindingContext === 'object')
            ? (_openBlock(), _createBlock(CellTableResultsDetails, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(CellDetailType2, {
                    title: renderValue(item.scanItemExpected)
                  }, null, 8, ["title"])
                ]),
                _: 2
              }, 1024))
            : (_openBlock(), _createBlock(CellTableResultsDetails, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(CellDetailType4, {
                    title: `${item.scanItemExpected || 'N/A'}`
                  }, null, 8, ["title"])
                ]),
                _: 2
              }, 1024))
      ]),
      "cell(unexpectedResult)": _withCtx(({
          item,
        }: {
          value: string;
          item: TypeStatusItem;
        }) => [
        (item.scanItemStatusId === ItemStatus.ok || checkIsIgnored(item))
          ? (_openBlock(), _createBlock(CellTableResultsDetails, {
              key: 0,
              "has-ignore": true,
              type: getItemType(item),
              "class-name": "tw-border-l-0 tw-rounded-l-none",
              "onUpdate:ignore": 
            (type) =>
              handleIgnoreOrIncludeItem(item, type)
          
            }, {
              default: _withCtx(() => [
                _createVNode(CellDetailType1, {
                  title: 
              getType1TitleForUnexpectedResult(`${item.scanItemExpected}`)
            ,
                  class: "tw-invisible"
                }, null, 8, ["title"])
              ]),
              _: 2
            }, 1032, ["type", "onUpdate:ignore"]))
          : (typeof item.scanItemFindingContext === 'object')
            ? (_openBlock(), _createBlock(CellTableResultsDetails, {
                key: 1,
                "has-detail": !_unref(isEmpty)(item.scanItemFindingContext),
                "has-ignore": true,
                type: getItemType(item),
                "is-show-detail": item.isShowDetail,
                "onUpdate:showDetail": ($event: any) => (item.isShowDetail = !item.isShowDetail),
                "onUpdate:ignore": 
            (type) =>
              handleIgnoreOrIncludeItem(item, type)
          
              }, {
                default: _withCtx(() => [
                  _createVNode(CellDetailType2, {
                    title: renderValue(item.scanItemFound),
                    detail: item.scanItemFindingContext,
                    "is-show-detail": item.isShowDetail
                  }, null, 8, ["title", "detail", "is-show-detail"])
                ]),
                _: 2
              }, 1032, ["has-detail", "type", "is-show-detail", "onUpdate:showDetail", "onUpdate:ignore"]))
            : (_openBlock(), _createBlock(CellTableResultsDetails, {
                key: 2,
                "has-detail": !_unref(isEmpty)(item.scanItemFindingContext),
                "has-ignore": true,
                type: getItemType(item),
                "is-show-detail": item.isShowDetail,
                "onUpdate:showDetail": ($event: any) => (item.isShowDetail = !item.isShowDetail),
                "onUpdate:ignore": 
            (type) =>
              handleIgnoreOrIncludeItem(item, type)
          
              }, {
                default: _withCtx(() => [
                  _createVNode(CellDetailType4, {
                    title: renderValue(item.scanItemFound),
                    detail: item.scanItemFindingContext,
                    "is-show-detail": item.isShowDetail
                  }, null, 8, ["title", "detail", "is-show-detail"])
                ]),
                _: 2
              }, 1032, ["has-detail", "type", "is-show-detail", "onUpdate:showDetail", "onUpdate:ignore"]))
      ]),
      _: 1
    }, 8, ["data", "custom-class", "is-loading", "empty-text"])
  ]))
}
}

})